import Loader from "../components/ui/Loader/Loader";

const RouteLoader = [
    {
        path: '*',
        element: <Loader sx={{ color: '#00578d' }} />,
    },
];
export default RouteLoader;
